import React, { FC } from 'react';

interface Props {
  className?: string;
  size?: number;
  color?: string;
}

export const PunchOutIcon: FC<Props> = ({ className, size = 24, color = 'currentColor' }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2 12L7 16V13H16V11H7V8L2 12Z" />
      <path d="M13.001 2.99906C11.8186 2.99578 10.6472 3.22717 9.55477 3.67982C8.46236 4.13247 7.47063 4.79739 6.63702 5.63606L8.05102 7.05006C9.37302 5.72806 11.131 4.99906 13.001 4.99906C14.871 4.99906 16.629 5.72806 17.951 7.05006C19.273 8.37206 20.002 10.1301 20.002 12.0001C20.002 13.8701 19.273 15.6281 17.951 16.9501C16.629 18.2721 14.871 19.0011 13.001 19.0011C11.131 19.0011 9.37302 18.2721 8.05102 16.9501L6.63702 18.3641C8.33602 20.0641 10.596 21.0011 13.001 21.0011C15.406 21.0011 17.666 20.0641 19.365 18.3641C21.065 16.6651 22.002 14.4051 22.002 12.0001C22.002 9.59506 21.065 7.33506 19.365 5.63606C18.5314 4.79739 17.5397 4.13247 16.4473 3.67982C15.3549 3.22717 14.1835 2.99578 13.001 2.99906Z" />
    </svg>
  );
};
